<template>
  <div class="service">
    <div class="banner">
      <div class="con-w">
        <img src="../assets/service/banner1-1.png" alt="" class="banner1-1" />
      </div>
    </div>
    <div class="r3">
      <div class="con-w">
        <h3 class="r-tit">携手各大招聘平台，联合举办双选会，共享优质资源</h3>
        <div class="r3-center">
          <img src="../assets/service/r3-img1.png" alt="" class="r3-img1" />
          <img src="../assets/service/r3-img2.png" alt="" class="r3-img2" />
        </div>
      </div>
    </div>
    <div class="r4">
      <div class="con-w">
        <h3 class="r-tit hred">双选会—现场面试，高效快捷招求共赢</h3>
        <div class="contain2">
          <div class="con2_main">
            <video controls="" name="media" class="con2-video" ref="con2Video">
              <source
                src="https://ow.qfedu.com/36jsxh.mp4"
                type="video/mp4"
              />
            </video>
            <!-- <div class="con2_mask"></div> -->
            <div class="con2_right">
              <div class="con2_container">
                <span class="btn"></span>
                <h4>双选会列表</h4>
                <div class="scroll">
                  <ul>
                    <li
                      v-for="(item, index) in r4List"
                      :key="index"
                      @click="handleR4Video(index)"
                    >
                      <span>{{ item.tit }}</span>
                      <i>{{ item.con }}</i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="r5">
      <div class="con-w">
        <h3 class="r-tit">上门招聘—送岗位上门，足不出户入名企</h3>
        <ul class="r5-lists">
          <li
            v-for="(item, index) in r5Lists"
            :key="index"
            @click="handleGoDetail(item.url)"
          >
            <img :src="item.pic" alt="" />
            <p>{{ item.txt }}</p>
          </li>
        </ul>
        <a
          href="http://www.qfedu.com/cooperation/recruit/"
          target="_blank"
          class="r5-btn"
          >查看更多</a
        >
      </div>
    </div>
    <div class="r6">
      <div class="con-w">
        <h3 class="r-tit hred">企业的肯定，学员的认同 是千锋不断向前的动力</h3>
        <div class="contain4 section">
          <div class="base11">
            <ul class="con4_list2 wow">
              <li>
                <a
                  data-vid="https://ow.qfedu.com/soufangwang.mp4"
                  href="javascript:;"
                >
                  <div>
                    <img
                      src="http://www.qfedu.com/d/file/hzsp/19bd6b9b5a6bd0c7f2c1a95100e5282d.jpg"
                    /><span></span>
                  </div>
                  <p>
                    <span>搜房网</span><i>学员水平吊打同行 搜房网HR不吝赞美</i>
                  </p></a
                >
              </li>
              <li>
                <a
                  data-vid="https://ow.qfedu.com/zhangqu.mp4"
                  href="javascript:;"
                >
                  <div>
                    <img
                      src="http://www.qfedu.com/d/file/hzsp/653ee837ea4d7d26a8ef4bc720721898.jpg"
                    /><span></span>
                  </div>
                  <p>
                    <span>掌趣科技</span><i>掌趣科技战果丰硕 受益良多</i>
                  </p></a
                >
              </li>
              <li>
                <a
                  data-vid="https://ow.qfedu.com/fenghuangxueyi.mp4"
                  href="javascript:;"
                >
                  <div>
                    <img
                      src="http://www.qfedu.com/d/file/hzsp/b3b628420f31922b5642eac8647b98be.jpg"
                    /><span></span>
                  </div>
                  <p>
                    <span>凤凰学易</span><i>凤凰学易甄选优才 暂定5人入职</i>
                  </p></a
                >
              </li>
              <li>
                <a
                  data-vid="https://ow.qfedu.com/fuxinruanjiankaifa.mp4"
                  href="javascript:;"
                >
                  <div>
                    <img
                      src="http://www.qfedu.com/d/file/hzsp/287d035f03d7e1fce0a62bb97b6247d9.jpg"
                    /><span></span>
                  </div>
                  <p>
                    <span>福昕软件</span><i>入职5人非常优秀 福昕软件再次选拔</i>
                  </p></a
                >
              </li>
              <li>
                <a
                  data-vid="https://ow.qfedu.com/shuzijiaxin.mp4"
                  href="javascript:;"
                >
                  <div>
                    <img
                      src="http://www.qfedu.com/d/file/hzsp/9e3e4054d18c3d3e4d359516b22bf5bb.jpg"
                    /><span></span>
                  </div>
                  <p>
                    <span>数字佳音</span><i>技术官慧眼识人 堪破千锋教学本质</i>
                  </p></a
                >
              </li>
              <li>
                <a
                  data-vid="https://ow.qfedu.com/wanhuatongxiner.mp4"
                >
                  <div>
                    <img
                      src="http://www.qfedu.com/d/file/hzsp/2781ace32d6530d5215142c0b8f0f37d.jpg"
                    /><span></span>
                  </div>
                  <p>
                    <span>万花筒信儿</span><i>综合实力满足要求 复试邀请CTO</i>
                  </p></a
                >
              </li>
            </ul>
          </div>
          <div class="c-alert" style="display: none">
            <div class="alert-video">
              <span class="alert-close">
                <img src="http://www.goodprogrammer.org/img/close.png" alt="" />
              </span>
              <div class="video"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="r7">
      <div class="con-w">
        <div class="contain5 section">
          <div class="base11">
            <h3 class="r-tit">求职招聘 报名通道</h3>
            <div class="wow r7-img1">
              <p class="con5_mask">
                <span class="shenqing">人才申请</span>
              </p>
            </div>
            <div class="wow r7-img2">
              <p class="con5_mask">
                <span
                  ><a
                    href="http://wpa.qq.com/msgrd?v=3&amp;uin=2453050692&amp;site=qq&amp;menu=yes"
                    target="_blank"
                    >企业申请</a
                  ></span
                >
              </p>
            </div>
          </div>
          <div class="con5_alert">
            <div class="con5_wrap">
              <h6>申请参加<span class="con5_close"></span></h6>
              <form action="">
                <input type="text" id="usename" placeholder="输入姓名" />
                <input type="text" id="tel" placeholder="输入电话" />
                <input type="text" id="email" placeholder="输入邮箱" />
                <input type="text" id="QQ" placeholder="输入QQ" />
                <input
                  class="con5_btn"
                  id="submit"
                  type="submit"
                  value="提交申请"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import myFooter from "@/components/myFooter";
import $ from "jquery";
export default {
  name: "service",
  data() {
    return {
      r5Lists: [
        {
          pic: require("../assets/service/r5-1.png"),
          txt: "中链宝公司面试官亲临千锋教育郑州校区招聘 前端工程师",
          url: "http://www.qfedu.com/cooperation/recruit/68398.html",
        },
        {
          pic: require("../assets/service/r5-2.png"),
          txt: "中业汇赢面试官亲临千锋教育郑州分校招聘 前端工程师",
          url: "http://www.qfedu.com/cooperation/recruit/68393.html",
        },
        {
          pic: require("../assets/service/r5-3.png"),
          txt: "鸿图四海面试官莅临千锋教育西安分校招纳贤才",
          url: "http://www.qfedu.com/cooperation/recruit/68387.html",
        },
        {
          pic: require("../assets/service/r5-4.png"),
          txt: "长荣集团面试官前往千锋教育郑州校区进行上门招聘",
          url: "http://www.qfedu.com/cooperation/recruit/68379.html",
        },
        {
          pic: require("../assets/service/r5-5.png"),
          txt: "聚思鸿面试官亲临千锋教育沈阳校区进行二次上门招聘",
          url: "http://www.qfedu.com/cooperation/recruit/68367.html",
        },
        {
          pic: require("../assets/service/r5-6.png"),
          txt: "聚思鸿信息技术面试官亲临千锋教育大连校区招聘前端工程师",
          url: "http://www.qfedu.com/cooperation/recruit/67924.html",
        },
      ],
      r4List: [
        {
          tit: "双选会第41季",
          con: "一次双选超越50次简历投递，高效就业火热开启",
        },
        {
          tit: "双选会第40季",
          con: "批量学员直入面试环节，全员offer一步之遥",
        },
        {
          tit: "双选会第39季",
          con: "直击高满意度招聘现场，双选会打开IT求职新模式",
        },
        {
          tit: "双选会第38季",
          con: "打破互联网沟通限度，千锋教育专业度备受肯定",
        },
        {
          tit: "双选会第37季",
          con: "无悔入千锋！求职学员面试现场吐露心声",
        },
        {
          tit: "双选会第36季",
          con: "技术过硬超乎想象 企业技术官现场点评面试学员",
        },
        {
          tit: "双选会第35季",
          con: "国企外企争相纳才 IT产业闭环培养模式效果显著",
        },
        {
          tit: "双选会第34季",
          con: "5G平台现场直聘 双选会打开就业新风口",
        },
        {
          tit: "双选会第33季",
          con: "素质技能双达标，面试官现场高赞千锋学员",
        },
        {
          tit: "双选会第32季",
          con: "好机会搏出大未来，双选会让万千梦想真实落地",
        },
        {
          tit: "双选会第31季",
          con: "一地学习全国就业，四城联动为百家企业输送精英",
        },
        {
          tit: "双选会第30季",
          con: "就业现场倾吐心声 良心教育备受肯定",
        },
        {
          tit: "双选会第29季",
          con: "面试现场分享求职心得，学员水平HR大为赞赏",
        },
        {
          tit: "双选会第28季",
          con: "高管初次参会叹服学员实战能力，“下一次，请一定通知我们”",
        },
        {
          tit: "双选会第27季",
          con: "扎心现场！大批学员挺进复试 企业方激动不已",
        },
        {
          tit: "双选会第26季",
          con: "屡获面试邀约！双选会为何如此神奇？",
        },
        {
          tit: "双选会第25季",
          con: "技术官多次参会，招才纳贤首选千锋",
        },
        {
          tit: "双选会第24季",
          con: "学员技能满足需求，联想HR赞许千锋教学",
        },
        {
          tit: "双选会第23季",
          con: "高度契合研发岗位需求，千锋学员远超同行水平",
        },
        {
          tit: "双选会第22季",
          con: "实力为王闯会场，学员颠覆招聘人员传统认知",
        },
        {
          tit: "双选会第21季",
          con: "老学员现场开心扉，谋求更多上升机会",
        },
        {
          tit: "双选会第20季",
          con: "超强技术针对性，直击与会企业核心需求",
        },
        {
          tit: "双选会第19季",
          con: "满意！企业HR直观评价千锋学员技术能力",
        },
        {
          tit: "双选会第18季",
          con: "宅急送现场选才，多位候选人等待面试",
        },
        {
          tit: "双选会第17季",
          con: "掌趣科技硕果累累，HR此行满载而归",
        },
        {
          tit: "双选会第16季",
          con: "技术水平被普遍认可，学员就业压力骤减",
        },
        {
          tit: "双选会第15季",
          con: "椅子网犀利点评，学员竞争优势大揭秘",
        },
        {
          tit: "双选会第14季",
          con: "现场斩获多份Offer！双选会缘何被称“最人性化”？",
        },
        {
          tit: "双选会第13季",
          con: "表白心仪企业，这一次，终于见到了“活的”",
        },
        {
          tit: "双选会第12季",
          con: "老学员再次参会，在梦开始的地方寻求新机遇",
        },
        {
          tit: "双选会第11季",
          con: "招走5人之后HR再临会场，信赖，就是这么简单",
        },
        {
          tit: "双选会第10季",
          con: "震惊！凤凰网HR神秘登场，深度解构学员技能优势",
        },
        {
          tit: "双选会第9季",
          con: "女程序员霸气规划未来，技术官现场谈高薪",
        },
        {
          tit: "双选会第8季",
          con: "高匹配度招聘，要的就是效率",
        },
        {
          tit: "双选会第7季",
          con: "群星云集共赞教学质量，学员入职信心满满",
        },
        {
          tit: "双选会第6季",
          con: "专场招聘良才并现，大范围满足企业转型需求",
        },
        {
          tit: "双选会第5季",
          con: "打破职场壁垒，用技术问鼎理想企业",
        },
        {
          tit: "双选会第4季",
          con: "名企HR诚意相邀，数名学员实力入职",
        },
        {
          tit: "双选会第3季",
          con: "上市企业争相纳才，千锋学员备受青睐",
        },
        {
          tit: "双选会第2季",
          con: "火爆现场人头攒动，企业HR的招聘天堂",
        },
        {
          tit: "双选会第1季",
          con: "行业首例双选会，充满惊喜与感动",
        },
      ],
      videoArr: [
        "https://ow.qfedu.com/千锋第41季双选会-双选嘉年华 offer零距离.mp4",
        "https://ow.qfedu.com/第40届双选会.mp4",
        "https://ow.qfedu.com/39季双选会 .mp4",
        "https://ow.qfedu.com/38季双选会.mp4",
        "https://ow.qfedu.com/37季双选会.mp4",
        "https://ow.qfedu.com/36jsxh.mp4",
        "https://ow.qfedu.com/35jmqzph.mp4",
        "https://ow.qfedu.com/sxh34.mp4",
        "https://ow.qfedu.com/sxh33.mp4",
        "https://ow.qfedu.com/32sxh.mp4",
        "https://ow.qfedu.com/31sxh.mp4",
        "https://ow.qfedu.com/disanshijimingqishaungxuanhui.mp4",
        "https://ow.qfedu.com/diershijiujimingqizhaopinhui.mp4",
        "https://ow.qfedu.com/28jishuangxuanhui.mp4",
        "https://ow.qfedu.com/27jishuangxuanhui.mp4",
        "https://ow.qfedu.com/26jishuangxuanhui.mp4",
        "https://ow.qfedu.com/25jishuangxuanhui.mp4",
        "https://ow.qfedu.com/24jishuangxuanhui.mp4",
        "https://ow.qfedu.com/23、diershisanji.mp4",
        "https://ow.qfedu.com/22、diershierji.mp4",
        "https://ow.qfedu.com/21diershiyiji.mp4",
        "https://ow.qfedu.com/20、diershiji.mp4",
        "https://ow.qfedu.com/19、dishijiuji.mp4",
        "https://ow.qfedu.com/18、dishibaji.mp4",
        "https://ow.qfedu.com/17、dishiqiji.mp4",
        "https://ow.qfedu.com/16、dishiliuji.mp4",
        "https://ow.qfedu.com/15、dishiwuji (2).mp4",
        "https://ow.qfedu.com/14、dishisiji (2).mp4",
        "https://ow.qfedu.com/13、dishisanji (2).mp4",
        "https://ow.qfedu.com/12、dishierji (2).mp4",
        "https://ow.qfedu.com/11、dishierji(2).mp4",
        "https://ow.qfedu.com/10、dishiji(2).mp4",
        "https://ow.qfedu.com/9、dijiuji(1).mp4",
        "https://ow.qfedu.com/8、dibaji.mp4",
        "https://ow.qfedu.com/7、diqiji.mp4",
        "https://ow.qfedu.com/6、diliuji.mp4",
        "https://ow.qfedu.com/5、diwuji.mp4",
        "https://ow.qfedu.com/4、disiji.mp4",
        "https://ow.qfedu.com/3、disanji(1).mp4",
        "https://ow.qfedu.com/2、dierji.mp4",
        "https://ow.qfedu.com/1.diyiji.mp4",
      ],
      // c3IconLists: [
      //   { icon: require('../assets/c3-icon1.png'), showAni: false },
      //   { icon: require('../assets/c3-icon2.png'), showAni: false },
      //   { icon: require('../assets/c3-icon3.png'), showAni: false },
      //   { icon: require('../assets/c3-icon4.png'), showAni: false }
      // ]
    };
  },
  mounted() {
    $(function () {
      $(".shenqing").click(function () {
        $(".con5_alert").show();
      });
      $(".con5_close").click(function () {
        $(".con5_alert").hide();
      });
    });

    $(function () {
      $(".contain5 .base11 div").mouseenter(function () {
        $(this).find(".con5_mask").fadeIn();
      });
      $(".contain5 .base11 div").mouseleave(function () {
        $(this).find(".con5_mask").fadeOut();
      });
    });
    $(function () {
      $(".contain4 li a").each(function () {
        $(this).click(function () {
          var vid = $(this).attr("data-vid");

          if (vid.length < 15) {
            $(".video")
              .html("")
              .html(
                '<embed src="http://static.video.qq.com/TPout.swf?vid=' +
                  vid +
                  '&amp;auto=0" wmode="transparent" allowfullscreen="true" quality="high"  width="580" height="440" align="middle" allowscriptaccess="always">'
              );
          } else {
            $(".video")
              .html("")
              .html(
                '<embed src="' +
                  vid +
                  '" allowfullscreen="true" quality="high"  width="580" height="440" align="middle" allowscriptaccess="always">'
              );
          }

          $(".c-alert").css("display", "block");
        });
      });

      $(".alert-close").click(function () {
        $(".c-alert").css("display", "none");
        $(".video").html("");
      });
    });
    var num = 1;
    $(".con2_container .btn").mouseenter(function () {
      if (num) {
        $(".con2_container").animate({ left: "270" }, function () {
          num = 0;
        });
        $(this).addClass("hover");
      } else {
        $(".con2_container").animate({ left: "0px" }, function () {
          num = 1;
        });
        $(this).removeClass("hover");
      }
    });
  },
  methods: {
    handleR4Video(index) {
      console.log(index);
      this.$refs.con2Video.src = this.videoArr[index];
    },
    handleGoDetail(url) {
      window.open(url);
    },
  },
  components: {
    // myFooter,
  },
};
</script>

<style scoped>
a {
  cursor: pointer;
  text-decoration: none;
}
.con-w {
  position: relative;
  width: 1200px;
  margin: 0 auto;
}
.banner {
  position: relative;
  height: 850px;
  background: url(../assets/service/banner1.jpg) no-repeat;
  background-size: cover;
  background-position: center top;
}
.banner1-1 {
  position: absolute;
  top: 406px;
  left: 50%;
  transform: translateX(-50%);
  width: 820px;
  height: 176px;
  animation: banner1 1s;
}
.r-tit {
  font-family: MicrosoftYaHei-Bold;
  font-size: 48px;
  font-weight: bold;
  text-align: center;
  padding-top: 58px;
  color: #ececec;
}
.hred {
  color: #d8584f !important;
}

.r3 {
  width: 100%;
  height: 771px;
  background: url(../assets/service/r3-bg.png) no-repeat;
  background-size: cover;
  background-position: center top;
}
.r3 .r-tit {
  padding-top: 80px;
}
.r3-center {
  position: relative;
  width: 1200px;
  height: 509px;
  background: url(../assets/service/r3-img3.png) no-repeat;
  background-size: 573px 509px;
  background-position: top center;
  margin: 96px auto 0 auto;
}
.r3-img1 {
  position: absolute;
  top: 152px;
  left: 20px;
  width: 375px;
  height: 322px;
}
.r3-img2 {
  position: absolute;
  top: 152px;
  right: 20px;
  width: 375px;
  height: 322px;
}

.r4 {
  width: 100%;
  height: 897px;
  background: url(../assets/service/r4-bg.jpg) no-repeat;
  background-size: cover;
  background-position: center top;
}
.contain2 h3 {
  font-size: 40px;
  font-weight: 900;
  color: #57bef3;
  text-align: center;
  position: relative;
  margin-bottom: 30px;
}
.contain2 h3 span {
  display: block;
  font-size: 24px;
  color: #999999;
  margin-bottom: 10px;
}
.contain2 h3 span i {
  font-size: 35px;
  color: #333;
  font-style: italic;
  margin-right: 10px;
}
.contain2 h3:after {
  content: "";
  display: block;
  position: absolute;
  width: 395px;
  height: 1px;
  background: #57bef3;
  top: 52px;
  left: 50%;
  margin-left: -197px;
}

.con2_main {
  position: relative;
  width: 1160px;
  height: 640px;
  background-color: #2d3349;
  border: solid 2px #242a3f;
  margin: 48px auto 0 auto;
}
.con2-video {
  display: block;
  width: 1100px;
  height: 619px;
  margin: 10px auto 0 auto;
}
.con2_right {
  position: absolute;
  top: 0px;
  right: 30px;
  width: 320px;
  overflow: hidden;
}
.con2_container {
  position: relative;
  background-color: rgba(53, 60, 86, 0.8);
  width: 270px;
  height: 619px;
  margin-top: 10px;
  float: right;
}
.btn {
  width: 30px;
  height: 80px;
  position: absolute;
  background: rgba(53, 60, 86, 0.8) url(../assets/service/r4-right.png)
    no-repeat center;
  top: 260px;
  left: -29px;
  border-radius: 7px 0 0 7px;
  cursor: pointer;
}
.btn.hover {
  background: rgba(53, 60, 86, 0.8) url(../assets/service/r4-left.png) no-repeat
    center;
}
.con2_container h4 {
  font-family: MicrosoftYaHei-Bold;
  font-size: 24px;
  font-weight: bold;
  color: #ececec;
  text-align: center;
  margin-bottom: 40px;
  padding-top: 34px;
}

.con2_container ul li {
  width: 250px;
  padding-left: 20px;
  padding-bottom: 48px;
  cursor: pointer;
}
.con2_container ul li span {
  display: block;
  color: #fff;
  font-size: 18px;
  margin-bottom: 16px;
  font-weight: bold;
}
.con2_container ul li i {
  color: #ececec;
  font-size: 16px;
  display: block;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-style: normal;
}
.r4 .scroll ul {
  height: 466px;
  padding-bottom: 48px;
  overflow-y: auto;
}
.r4 .scroll ul::-webkit-scrollbar {
  display: none;
}
.r4 .scroll ul li:last-child {
  padding-bottom: 0;
}
.r5 {
  width: 100%;
  height: 1012px;
  background: url(../assets/service/r5-bg.jpg) no-repeat;
  background-size: cover;
}
.r5-lists {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 1160px;
  margin: 85px auto 0 auto;
}
.r5-lists li {
  position: relative;
  width: 385px;
  height: 310px;
}
.r5-lists li img {
  width: 385px;
  height: 216px;
  /* object-fit: cover; */
  transition: 0.5s all;
  transform-origin: center;
}
.r5-lists li img:hover {
  position: absolute;
  top: -10px;
  left: -20px;
  width: 424px;
  height: 238px;
  background-color: #51576e;
  box-shadow: 0px 0px 13px 0px rgba(27, 33, 59, 0.41);
  z-index: 1;
}
.r5-lists li p {
  position: absolute;
  top: 236px;
  left: 50%;
  transform: translateX(-50%);
  width: 252px;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  line-height: 1.6;
  color: #ececec;
}
.r5-btn {
  display: block;
  width: 250px;
  height: 50px;
  background-color: #ececec;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  line-height: 50px;
  color: #445157;
  text-align: center;
  margin: 54px auto 0 auto;
}

.r6 {
  position: relative;
  width: 100%;
  height: 914px;
  background: #ffffff;
}

/*contain4 现场实况*/

.contain4 ul {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 1160px;
  margin: 74px auto 0 auto;
}

.con4_list2 li {
  width: 380px;
  border: solid 1px #9a9daa;
  margin-bottom: 36px;
  padding-bottom: 14px;
}
.con4_list2 li div {
  position: relative;
  width: 368px;
  height: 208px;
  margin: 5px auto 16px auto;
}
.con4_list2 li div img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.con4_list2 li div span {
  display: block;
  position: absolute;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: url(http://img.mobiletrain.org/templates/mobiletrain/images/sxh_20170612/con4_video2.png)
    no-repeat center;
  right: 10px;
  bottom: 10px;
}
.con4_list2 li p span {
  display: block;
  font-size: 18px;
  color: #445157;
  margin-bottom: 5px;
  padding-left: 5px;
}
.con4_list2 li p i {
  display: block;
  font-size: 14px;
  color: #445157;
  padding-left: 5px;
  font-style: normal;
}
.c-alert {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  z-index: 1000;
  display: none;
}
.c-alert .alert-video {
  height: 440px;
  width: 580px;
  color: #bbb;
  border: 1px solid #444;
  padding: 3px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin: -220px 0 0 -290px;
  z-index: 100;
}
.c-alert .alert-close {
  width: 25px;
  height: 29px;
  position: absolute;
  right: -16px;
  top: -15px;
  cursor: pointer;
}
/*contain5  我要参加*/
.contain5 h3 {
  text-align: center;
  margin-bottom: 86px;
  padding-top: 76px;
}
.contain5 .base11 {
  overflow: hidden;
}
.contain5 .base11 div:nth-child(2) {
  float: left;
}
.contain5 .base11 div:nth-child(3) {
  float: right;
}
/* .contain5 .base11 div {
  position: relative;
  width: 544px;
  height: 308px;
  overflow: hidden;
} */
.r7-img1 {
  position: relative;
  width: 544px;
  height: 308px;
  background: url(../assets/service/r7-img1.jpg) no-repeat;
  background-position: center right;
}
.r7-img2 {
  position: relative;
  width: 544px;
  height: 308px;
  background: url(../assets/service/r7-img2.jpg) no-repeat;
  background-position: center right;
}
.contain5 .base11 div .con5_mask {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 544px;
  height: 308px;
  background: rgba(0, 0, 0, 0.5);
  display: none;
}

.contain5 .base11 div .con5_mask span {
  display: block;
  width: 320px;
  height: 64px;
  border-radius: 32px;
  background: #d8584f;
  text-align: center;
  line-height: 64px;
  font-size: 24px;
  color: #fff;
  margin: 120px auto 0;
  cursor: pointer;
}
.contain5 .base11 div:nth-child(3) .con5_mask span {
  background: #ececec;
}
.contain5 .base11 div:nth-child(3) .con5_mask span a {
  color: #d8584f;
}

.con5_alert {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  z-index: 1000;
  display: none;
}
.con5_alert .con5_wrap {
  width: 500px;
  height: 408px;
  border-radius: 10px;
  background: #fff;
  position: fixed;
  left: 50%;
  top: 50%;
  margin: -204px 0 0 -250px;
}
.r7 .con5_alert .con5_wrap h6 {
  text-align: center;
  padding: 20px;
  font-size: 24px;
  color: #ff546f;
  position: relative;
  margin-bottom: 25px;
  margin-top: 0;
}
.con5_alert .con5_wrap h6 span {
  display: block;
  float: right;
  width: 18px;
  height: 18px;
  margin-top: 10px;
  cursor: pointer;
  background: url(http://img.mobiletrain.org/templates/mobiletrain/images/sxh_20170612/con5_close.png)
    no-repeat center;
}
.con5_alert .con5_wrap h6:after {
  content: "";
  display: block;
  position: absolute;
  width: 500px;
  height: 2px;
  background: url(http://img.mobiletrain.org/templates/mobiletrain/images/sxh_20170612/con5_xian.jpg)
    no-repeat center;
  bottom: 0px;
  left: 0px;
}
.con5_alert .con5_wrap form {
  width: 340px;
  margin: 0 auto;
}
.con5_alert div form input {
  width: 258px;
  height: 42px;
  border: 1px solid #dddddd;
  margin-bottom: 20px;
  border-radius: 8px;
  font-size: 14px;
  color: #aaa;
  padding-left: 80px;
}
.con5_alert div form input:nth-child(1) {
  background: url(http://img.mobiletrain.org/templates/mobiletrain/images/sxh_20170612/form_img1.png)
    no-repeat 25px 10px;
}
.con5_alert div form input:nth-child(2) {
  background: url(http://img.mobiletrain.org/templates/mobiletrain/images/sxh_20170612/form_img2.png)
    no-repeat 25px 10px;
}
.con5_alert div form input:nth-child(3) {
  background: url(http://img.mobiletrain.org/templates/mobiletrain/images/sxh_20170612/form_img3.png)
    no-repeat 25px 10px;
}
.con5_alert div form input:nth-child(4) {
  background: url(http://img.mobiletrain.org/templates/mobiletrain/images/sxh_20170612/form_img4.png)
    no-repeat 25px 10px;
}
.con5_alert div form .con5_btn {
  display: block;
  width: 200px;
  height: 40px;
  border: 0px;
  border-radius: 20px;
  background: #ff546f;
  font-size: 18px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  margin: 0 auto;
  padding-left: 0px;
  cursor: pointer;
}
.r7 {
  width: 100%;
  height: 745px;
  background: url(../assets/service/r7-bg.png);
  background-size: cover;
  background-position: top center;
}

@media (min-width: 1600px) {
  .con-w {
    width: 1600px;
    margin: 0 auto;
  }
  .r3-img1 {
    left: -60px;
  }
  .r3-img2 {
    right: -60px;
  }
  .con2_main {
    width: 1240px;
    height: 660px;
  }
  .con2-video {
    margin-top: 20px;
  }
  .con2_right {
    right: 70px;
  }
  .con2_container {
    margin-top: 20px;
  }
  .r7-img1,
  .r7-img2,
  .contain5 .base11 div .con5_mask {
    width: 724px;
  }
  .r5 {
    height: 1112px;
  }
  .r5-lists {
    width: 1448px;
  }
  .r5-lists li {
    width: 473px;
    height: 378px;
  }
  .r5-lists li img {
    width: 473px;
    height: 270px;
  }
  .r5-lists li img:hover {
    width: 528px;
    height: 297px;
  }
  .slide-2 {
    left: 270px;
  }
  .slide2-2 {
    left: 560px;
  }
  .r5-lists li p {
    top: 286px;
  }
  .contain4 ul {
    width: 1448px;
  }
  .con4_list2 li {
    width: 472px;
  }
  .con4_list2 li div {
    width: 456px;
  }
}

@keyframes banner1 {
  0% {
    top: 416px;
  }
  100% {
    top: 406px;
  }
}
</style>
